import React, { useState, useEffect, useRef } from "react";
// import {useHistory} from 'react-router-dom';
// import {useDispatch} from 'react-redux';

import { selectCategories } from "../features/categories/categoriesSlice";
import {
  preSignedURL,
  bulkStatusUpdate,
  bulkCategoryUpdate,
} from "../features/products/productsSlice";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import clsx from "clsx";
import { lighten, makeStyles, withStyles } from "@material-ui/core/styles";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import InputBase from "@material-ui/core/InputBase";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Container from "@material-ui/core/Container";
import Menu from "@material-ui/core/Menu";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Button from "@material-ui/core/Button";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import TableSelect from "./TableSelect";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import SearchIcon from "@material-ui/icons/Search";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CSVDownload from "./CSVDownload";
import LocalDialog from "./LocalDialog";
import Brand from "../features/brands/Brand";
import Courier from "../features/couriers/Courier";
import Orders from "../features/orders/Orders";
import Invoices from "../features/invoices/Invoices";
import PurchaseOrders from "../features/purchaseOrders/PurchaseOrders";
import User from "../features/users/User";
import Client from "../features/clients/Client";
import { Link } from "react-router-dom";
import Supplier from "../features/suppliers/Supplier";
import Category from "../features/categories/Category";
import { fetchClients, selectClients } from "../features/clients/clientsSlice";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";

import CategoriesSelect from "../components/CategoriesSelect";
import Calculator from "../features/products/Calculator";
import Datepicker from "../components/TableDatepicker";
import DescriptionDialog from "../features/products/DescriptionDialog";
import ImageDialog from "../features/products/ImageDialog";
import BulkConfirmDialog from "./BulkConfirmDialog";

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const StyledTableCell = withStyles((theme) => ({
  head: {
    // border: '1px solid rgb(224, 224, 224)',
    fontSize: 12,
    maxWidth: 150,
    padding: 0,
    paddingBottom: 5,
    paddingLeft: 5,
    minWidth: 100,
  },
  body: {
    cursor: "pointer",
    border: "1px solid rgb(224, 224, 224)",
    fontSize: 12,
    lineHeight: 1.43,
    maxWidth: 150,
    textOverflow: "ellipsis",
    overflow: "hidden",
    padding: 0,
    paddingRight: 2,
    whiteSpace: "nowrap",
    paddingLeft: 5,
  },
}))(TableCell);

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function ColumnMenu(props) {
  const { rowList, handleRowFilter } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="column-menu"
        aria-haspopup="true"
        onClick={handleClick}
        style={{
          marginLeft: 8,
          // marginTop: 16,
          color: "#fff",
        }}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="column-menu"
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            minWidth: 250,
            padding: 24,
            paddingLeft: 8,
          },
        }}
      >
        <FormControl component="fieldset">
          <FormLabel
            component="legend"
            style={{ paddingLeft: 16, marginBottom: 24 }}
          >
            Show Columns
          </FormLabel>
          <FormGroup>
            {rowList.map((option) => (
              <MenuItem key={option.id} style={{ padding: 0, paddingLeft: 16 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={option.checked}
                      onChange={handleRowFilter}
                      name={option.id}
                    />
                  }
                  label={option.label}
                />
              </MenuItem>
            ))}
          </FormGroup>
          <FormHelperText style={{ paddingLeft: 16, marginTop: 24 }}>
            {/* Be careful */}
          </FormHelperText>
        </FormControl>
      </Menu>
    </div>
  );
}

function TableActions(props) {
  const {
    classes,
    headCells,
    handleRowFilter,
    setSearchTerm,
    searchTerm,
    rowList,
    handleSearch,
    handleClear,
    editItem,
    checked,
    names,
    handleToggle,
    actionsLists,
    actionsHandleChange,
    actionsNames,
    area,
    selectNames,
    selected,
    selectedItem,
    data,
    setDateBefore,
    setDateAfter,
    dateAfter,
    dateBefore,
    fetchInvoices,
    jwtToken,
    clientProp,
    handleInvoiceClientChange,
    productsAmount,
    getFullList,
  } = props;
  const [menuPosition, setMenuPosition] = useState(null);

  const [localOpen, setLocalOpen] = useState(false);
  const [localValue, setLocalValue] = useState("Australia");

  const { clientsList } = useSelector(selectClients);

  const uploadFileToAWS = (newValue) => {
    if (fileInputRef.current.files.length) {
      let csvFile = fileInputRef.current.files[0];
      // handleFiles(fileInputRef.current.files);

      let jwtToken = localStorage.getItem("coreToken");
      // let name = `${uuidv4}`.csv;
      let data = {
        objectName: csvFile.name,
        objectType: "csv",
        token: jwtToken,
        csvFile,
        contentType: "text/csv",
        localization: newValue === "Australia" ? "en-AU" : "en-NZ",
      };
      dispatch(preSignedURL(data));
    }
  };

  const handleClose = (newValue) => {
    setLocalOpen(false);
    if (newValue) {
      setLocalValue(newValue);
      uploadFileToAWS(newValue);
    }
  };

  const { categoriesTree } = useSelector(selectCategories);
  const dispatch = useDispatch();
  const fileInputRef = useRef();

  const handleUpload = (e) => {
    if (fileInputRef.current.files.length) {
      setLocalOpen(true);
    }
  };

  const fileInputClicked = () => {
    fileInputRef.current.click();
  };

  const handleCatsOpen = (event) => {
    if (menuPosition) {
      return;
    }
    event.preventDefault();
    setMenuPosition({
      top: event.clientY,
      left: event.clientX,
    });
  };

  const handleEnter = (e) => {
    if (e.which == 13) {
      handleSearch();
    }
  };

  // export function uuidv4() {
  //   return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
  //     // eslint-disable-next-line
  //     var r = (Math.random() * 16) | 0,
  //       v = c == 'x' ? r : (r & 0x3) | 0x8;
  //     return v.toString(16);
  //   });
  // }
  // let textInput = useRef(null);
  return (
    <div className={classes.actionsContainer}>
      <div className={classes.actionsItem} style={{ marginRight: 0 }}>
        <ColumnMenu
          rowList={rowList}
          headCells={headCells}
          handleRowFilter={handleRowFilter}
        />
      </div>
      <div className={classes.addItem} style={{ flexGrow: 0 }}>
        {area === "brand" ? (
          <Brand />
        ) : area === "courier" ? (
          <Courier />
        ) : area === "user" ? (
          <User />
        ) : area === "order" ? (
          <Orders />
        ) : area === "invoice" ? (
          <Invoices />
        ) : area === "purchase-order" ? (
          <PurchaseOrders />
        ) : area === "supplier" ? (
          <Supplier />
        ) : area === "client" ? (
          <Client />
        ) : area === "product" ? (
          <a className={classes.accountLink} href="/products/new">
            <IconButton
              aria-label="add new"
              style={{ paddingLeft: 8, paddingRight: 8 }}
            >
              <AddCircleIcon className={classes.addIcon} />
            </IconButton>
          </a>
        ) : area === "category" ? (
          <Category
            checked={checked}
            names={names}
            handleToggle={handleToggle}
            categoriesTree={categoriesTree}
            list={false}
            classes={classes}
          />
        ) : (
          ""
        )}
      </div>
      {area === "product" && (
        <div className={classes.addItem} style={{ flexGrow: 0 }}>
          <input
            ref={fileInputRef}
            accept="text/csv"
            className={classes.input}
            id="icon-button-csv"
            type="file"
            onChange={handleUpload}
            style={{ display: "none" }}
          />
          <label htmlFor="icon-button-csv">
            <IconButton
              aria-label="upload csv"
              onClick={fileInputClicked}
              style={{
                // marginRight: 8,
                // marginTop: 16,
                paddingLeft: 8,
                paddingRight: 8,
                color: "#fff",
              }}
            >
              <CloudUploadIcon />
            </IconButton>
          </label>
          <LocalDialog
            open={localOpen}
            value={localValue}
            handleClose={handleClose}
          />
        </div>
      )}
      {/*  */}
      <CSVDownload
        data={
          area === "product"
            ? data.map((element) => {
                // console.log('images', element.images)
                if (element.images) {
                  return (element = Object.assign({}, element, {
                    images:
                      "https://assets.pointsshop.com.au/" +
                      element.images[0].objName,
                  }));
                } else {
                  return element;
                }
              })
            : data
        }
        productsAmount={productsAmount}
        getFullList={getFullList}
        rowList={rowList}
        headCells={headCells}
      />
      {(area === "product" || area === "category" || area === "order") && (
        <div className={classes.actionsItem}>
          <InputBase
            placeholder={area === "order" ? "Search Member…" : "Search…"}
            inputProps={{ "aria-label": "search" }}
            id="custom-search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyPress={(e) => handleEnter(e)}
          />
        </div>
      )}
      {area === "product" && (
        <div onClick={handleCatsOpen} className={classes.actionsItem}>
          <TableSelect
            update={false}
            classes={classes}
            filterList={[]}
            filterStatus={names}
            name={"category"}
            filterIDs={[]}
            handleFilterChange={actionsHandleChange[0]}
            multiple={true}
            cats={true}
          />
          <CategoriesSelect
            menuPosition={menuPosition}
            setMenuPosition={setMenuPosition}
            // handleOpen={handleCatsOpen}
            checked={checked}
            names={names}
            handleToggle={handleToggle}
            categoryTreeList={categoriesTree}
            edit={editItem}
            list={false}
            classes={classes}
          />
        </div>
      )}
      {actionsLists.map((list, index) => {
        return (
          <div className={classes.actionsItem} key={index}>
            <TableSelect
              key={index}
              update={false}
              classes={classes}
              filterList={actionsLists[index]}
              filterStatus={actionsNames[index]}
              name={selectNames[index]}
              handleFilterChange={actionsHandleChange[index]}
              multiple={
                selectNames[index] === "country"
                  ? false
                  : area === "product"
                  ? true
                  : area === "productsOrdered"
                  ? true
                  : selectNames[index] === "status"
              }
            />
          </div>
        );
      })}
      {area === "order" && (
        <div style={{ display: "flex" }}>
          <div style={{ maxWidth: 160, marginBottom: 16, marginRight: 16 }}>
            <Datepicker
              after={true}
              before={false}
              invoiceDate={dateAfter}
              setInvoiceDate={setDateAfter}
              report={true}
              label={"Orders after"}
            />
          </div>
          <div style={{ maxWidth: 160, marginBottom: 16, marginRight: 16 }}>
            <Datepicker
              after={false}
              before={true}
              invoiceDate={dateBefore}
              setInvoiceDate={setDateBefore}
              report={true}
              label={"Orders before"}
            />
          </div>
        </div>
      )}
      {area === "invoice" && (
        <div style={{ display: "flex" }}>
          <div style={{ maxWidth: 160, marginBottom: 16, marginRight: 16 }}>
            <Datepicker
              after={true}
              before={false}
              invoiceDate={dateAfter}
              setInvoiceDate={setDateAfter}
              report={true}
              label={"Invoices after"}
            />
          </div>
          <div style={{ maxWidth: 160, marginBottom: 16, marginRight: 16 }}>
            <Datepicker
              after={false}
              before={true}
              invoiceDate={dateBefore}
              setInvoiceDate={setDateBefore}
              report={true}
              label={"Invoices before"}
            />
          </div>
          {/* <div style={{ maxWidth: 160, marginBottom: 16, marginRight: 16 }}>
            <div>
              <FormControl
                style={{
                  width: 160,
                  backgroundColor: "white",
                  marginTop: 24,
                  borderRadius: 0,
                  display: "flex",
                  justifyContent: "flex-start",
                }}
              >
                <Select
                  value={clientProp}
                  style={{ marginTop: 0, padding: 0, height: 30 }}
                  onChange={actionsHandleChange[0]}
                  displayEmpty
                  inputProps={{
                    name: "client",
                    id: "client-simple",
                  }}
                >
                  <option value="" disabled>
                    Select Client
                  </option>
                  {clientsList.map((client) => (
                    <option key={client.id} value={client.id}>
                      {client.name}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div> */}
        </div>
      )}
      {area === "purchase-order" && (
        <div style={{ display: "flex" }}>
          <div style={{ maxWidth: 160, marginBottom: 16, marginRight: 16 }}>
            <Datepicker
              after={true}
              before={false}
              invoiceDate={dateAfter}
              setInvoiceDate={setDateAfter}
              report={true}
              label={"P.O. after"}
            />
          </div>
          <div style={{ maxWidth: 160, marginBottom: 16, marginRight: 16 }}>
            <Datepicker
              after={false}
              before={true}
              invoiceDate={dateBefore}
              setInvoiceDate={setDateBefore}
              report={true}
              label={"P.O. before"}
            />
          </div>
          <div style={{ maxWidth: 160, marginBottom: 16, marginRight: 16 }}>
            <div>
              <FormControl
                style={{
                  width: 160,
                  backgroundColor: "white",
                  marginTop: 24,
                  borderRadius: 0,
                  display: "flex",
                  justifyContent: "flex-start",
                }}
              >
                <Select
                  value={clientProp}
                  style={{ marginTop: 0, padding: 0, height: 30 }}
                  onChange={actionsHandleChange[0]}
                  displayEmpty
                  inputProps={{
                    name: "client",
                    id: "client-simple",
                  }}
                >
                  <option value={undefined} disabled>
                    Select Client
                  </option>
                  {clientsList.map((client) => (
                    <option key={client.id} value={client.id}>
                      {client.name}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
        </div>
      )}
      {area === "order-products" && (
        <div style={{ display: "flex" }}>
          <div style={{ maxWidth: 160, marginBottom: 16, marginRight: 16 }}>
            <Datepicker
              after={true}
              before={false}
              invoiceDate={dateAfter}
              setInvoiceDate={setDateAfter}
              report={true}
              label={"P.O. after"}
            />
          </div>
          <div style={{ maxWidth: 160, marginBottom: 16, marginRight: 16 }}>
            <Datepicker
              after={false}
              before={true}
              invoiceDate={dateBefore}
              setInvoiceDate={setDateBefore}
              report={true}
              label={"P.O. before"}
            />
          </div>
        </div>
      )}
      {area === "averageMargin" && (
        <div style={{ display: "flex" }}>
          <div style={{ maxWidth: 160, marginBottom: 16, marginRight: 16 }}>
            <Datepicker
              after={true}
              before={false}
              invoiceDate={dateAfter}
              setInvoiceDate={setDateAfter}
              report={true}
              label={"Orders after"}
            />
          </div>
          <div style={{ maxWidth: 160, marginBottom: 16, marginRight: 16 }}>
            <Datepicker
              after={false}
              before={true}
              invoiceDate={dateBefore}
              setInvoiceDate={setDateBefore}
              report={true}
              label={"Orders before"}
            />
          </div>
        </div>
      )}
      {area === "productsOrdered" && (
        <div style={{ display: "flex" }}>
          <div style={{ maxWidth: 160, marginBottom: 16, marginRight: 16 }}>
            <Datepicker
              after={true}
              before={false}
              invoiceDate={dateAfter}
              setInvoiceDate={setDateAfter}
              report={true}
              label={"Orders after"}
            />
          </div>
          <div style={{ maxWidth: 160, marginBottom: 16, marginRight: 16 }}>
            <Datepicker
              after={false}
              before={true}
              invoiceDate={dateBefore}
              setInvoiceDate={setDateBefore}
              report={true}
              label={"Orders before"}
            />
          </div>
        </div>
      )}

      <div
        onClick={handleSearch}
        className={classes.actionsItem}
        style={{ marginRight: 0 }}
      >
        <IconButton aria-label="search">
          <SearchIcon
            style={{
              color: "#fff",
            }}
          />
        </IconButton>
      </div>

      <div
        onClick={handleClear}
        style={{ marginRight: 0 }}
        className={classes.actionsItem}
      >
        <IconButton aria-label="clear filters">
          <HighlightOffIcon
            style={{
              marginRight: 0,
              color: "#fff",
            }}
          />
        </IconButton>
      </div>
      {area === "product" && selected.length === 1 && (
        <div>
          <Calculator product={selectedItem} edit={true} />
        </div>
      )}
    </div>
  );
}

// TableActions.propTypes = {
//   classes: PropTypes.object.isRequired,
//   numSelected: PropTypes.number.isRequired,
//   onRequestSort: PropTypes.func.isRequired,
//   onSelectAllClick: PropTypes.func.isRequired,
//   order: PropTypes.oneOf(['asc', 'desc']).isRequired,
//   orderBy: PropTypes.string.isRequired,
//   rowCount: PropTypes.number.isRequired,
//   selectAll: PropTypes.bool.isRequired,
// };

function EnhancedTableHead(props) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    selectAll,
    headCells,
    rowList,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead className={classes.tableHead}>
      <TableRow>
        <StyledTableCell
          style={
            selectAll
              ? { visibility: "visible", maxWidth: 50, minWidth: 30 }
              : { display: "none" }
          }
          padding="checkbox"
        >
          <Checkbox
            style={
              selectAll
                ? { visibility: "visible", paddingBottom: 5 }
                : { display: "hidden", paddingBottom: 5 }
            }
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ "aria-label": "select all desserts" }}
          />
        </StyledTableCell>
        {headCells.map((headCell, index) => (
          <StyledTableCell
            // className={classes.tableHead}
            key={headCell.id}
            align={"left"}
            // align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            style={
              index === 0 && !selectAll
                ? {
                    paddingLeft: 10,
                    display: rowList[index].checked ? "table-cell" : "none",
                  }
                : rowList[index].id === "categories" && rowList[index].checked
                ? { visiblity: "visible", minWidth: 300 }
                : rowList[index].long && rowList[index].checked
                ? { visiblity: "visible", minWidth: 175 }
                : rowList[index].dates && rowList[index].checked
                ? { visiblity: "visible", minWidth: 175 }
                : rowList[index].checked
                ? { visiblity: "visible", color: "red" }
                : { display: "none" }
            }
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              disabled={!headCell.sortable}
              onClick={
                headCell.sortable
                  ? headCell.object
                    ? null
                    : createSortHandler(headCell.id)
                  : null
              }
              className={classes.root}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  selectAll: PropTypes.bool.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    color: "#fff",
    backgroundColor: "#336699",
  },

  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
  filterIcon: {
    color: "#fff",
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected, area, selected, data } = props;

  const [statusName, setStatusName] = useState([]);
  const [statusID, setStatusID] = useState([]);
  const [statusList, setStatusList] = useState([
    { id: 1, value: "Active", name: "Active" },
    { id: 2, value: "Inactive", name: "Inactive" },
    { id: 3, value: "Deleted", name: "Deleted" },
    { id: 5, value: "Pending", name: "Pending" },
    { id: 16, value: "Dispatched", name: "Dispatched" },
    { id: 9, value: "Completed", name: "Completed" },
    { id: 21, value: "Declined", name: "Declined" },
    { id: 23, value: "Refunded", name: "Refunded" },
    { id: 24, value: "Processing", name: "Processing" },
    { id: 27, value: "Approved", name: "Approved" },
  ]);
  const dispatch = useDispatch();
  const { categoriesTree } = useSelector(selectCategories);

  const handleStatusChange = (event) => {
    let idsArr = [];
    let selectedStatus = statusList.filter(
      (status) => status.name === event.target.value
    );
    selectedStatus[0] && idsArr.push(selectedStatus[0].id);

    setStatusName(event.target.value);
    setStatusID(idsArr);
    // handleBulkStatusUpdate()
  };
  const [editItem, setEdit] = useState(false);

  const [newCatsChecked, setNewCatsChecked] = useState([]);
  const [catNames, setCatNames] = useState([]);
  const [menuPosition, setMenuPosition] = useState(null);
  const handleCatsToggle = (e, value, name) => {
    e.stopPropagation();
    const currentIndex = newCatsChecked.indexOf(value);
    const newChecked = [...newCatsChecked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    const currentNameIndex = catNames.indexOf(name);
    const newNames = [...catNames];

    if (currentNameIndex === -1) {
      newNames.push(name);
    } else {
      newNames.splice(currentNameIndex, 1);
    }
    setCatNames(newNames);
    setNewCatsChecked(newChecked);
  };
  let jwtToken = localStorage.getItem("coreToken");

  const handleSelect = () => {};

  const handleNewCatsOpen = (event) => {
    if (menuPosition) {
      return;
    }
    event.preventDefault();
    setMenuPosition({
      top: event.clientY,
      left: event.clientX,
    });
  };

  const [bulkOpen, setBulkOpen] = useState(false);
  const [bulkText, setBulkText] = useState("");
  const [bulkTitle, setBulkTitle] = useState("");

  const getProd = () => {
    let prod = {};
    if (selected.length === 1) {
      const selectedProd = data.filter((product) => product.id === selected[0]);
      if (selectedProd.length) {
        prod = selectedProd[0];
      }
    }
    return prod;
  };

  const handleBulkStatusUpdate = () => {
    const prod = getProd();
    if (prod.hasOwnProperty("name") && prod.hasOwnProperty("sku")) {
      setBulkText(
        `Set status for ${prod.name}, SKU: ${prod.sku} to ${statusName}.`
      );
    } else {
      setBulkText(
        `Set status for ${numSelected} ${
          numSelected === 1 ? "product" : "products"
        } to ${statusName}.`
      );
    }
    setBulkTitle("Update Status");
    setBulkOpen(true);
  };

  const handleBulkCategoryUpdate = () => {
    const prod = getProd();
    if (prod.hasOwnProperty("name") && prod.hasOwnProperty("sku")) {
      setBulkText(
        `Set categories for ${prod.name}, SKU: ${prod.sku} to ${
          catNames.length > 1 ? catNames.join(", ") : catNames
        }.`
      );
    } else {
      setBulkText(
        `Set categories for ${numSelected} ${
          numSelected === 1 ? "product" : "products"
        } to ${catNames.join(", ")}.`
      );
    }
    setBulkTitle("Update Categories");

    setBulkOpen(true);
  };

  const handleBulkClose = () => {
    setBulkOpen(false);
  };

  const handleBulkUpdate = () => {
    if (bulkTitle.includes("Categories")) {
      let prodsList = [];
      selected.forEach((prod) => {
        const selectedProd = data.filter((product) => product.id === prod);
        if (selectedProd.length) {
          prodsList.push(selectedProd[0]);
        }
      });
      dispatch(
        bulkCategoryUpdate({
          token: jwtToken,
          ids: selected,
          categoryIDs: newCatsChecked,
        })
      );
    } else if (bulkTitle.includes("Status")) {
      dispatch(
        bulkStatusUpdate({
          token: jwtToken,
          ids: selected,
          statusID: statusID[0],
        })
      );
    }
    setBulkOpen(false);
  };

  useEffect(() => {
    if (statusID.length) {
      handleBulkStatusUpdate();
    }
  }, [statusID]);

  return (
    <TableHead className={classes.tableHead}>
      <BulkConfirmDialog
        handleClose={handleBulkClose}
        title={bulkTitle}
        text={bulkText}
        setOpen={setBulkOpen}
        open={bulkOpen}
        handleBulk={handleBulkUpdate}
      />
      {numSelected > 0 && (
        <TableRow
          className={clsx(classes.root, {
            [classes.highlight]: numSelected > 0,
          })}
        >
          <TableCell align="center" colSpan={props.cols} style={{ padding: 0 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                paddingBottom: 4,
                paddingTop: 4,
              }}
            >
              {area === "product" && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: 16,
                  }}
                >
                  <div className={classes.actionsItem}>
                    <TableSelect
                      classes={classes}
                      filterList={statusList}
                      filterStatus={statusName}
                      name={"status"}
                      handleFilterChange={handleStatusChange}
                      multiple={false}
                      update={true}
                    />
                  </div>

                  {/* <div onClick={handleStatusUpdate}>
                    <ColorButton
                      disabled={!statusID.length}
                      style={{
                        margin: 8,
                        height: 24,
                        paddingLeft: 8,
                        paddingRight: 8,
                        width: 80,
                      }}
                    >
                      Update
                    </ColorButton>
                  </div> */}
                  <div
                    onClick={handleNewCatsOpen}
                    style={{ marginLeft: 16 }}
                    className={classes.actionsItem}
                  >
                    <TableSelect
                      update={true}
                      classes={classes}
                      filterList={[]}
                      filterStatus={catNames}
                      name={"category"}
                      filterIDs={[]}
                      handleFilterChange={handleSelect}
                      multiple={true}
                      cats={true}
                    />
                    <CategoriesSelect
                      closeCallback={handleBulkCategoryUpdate}
                      menuPosition={menuPosition}
                      setMenuPosition={setMenuPosition}
                      // handleOpen={handleCatsOpen}
                      checked={newCatsChecked}
                      names={catNames}
                      handleToggle={handleCatsToggle}
                      categoryTreeList={categoriesTree}
                      edit={editItem}
                      list={false}
                      classes={classes}
                    />
                  </div>
                </div>
              )}

              {numSelected > 0 ? (
                <Typography
                  className={classes.title}
                  color="inherit"
                  variant="subtitle1"
                  component="div"
                >
                  {numSelected} selected
                </Typography>
              ) : (
                <Typography
                  className={classes.title}
                  variant="h6"
                  id="tableTitle"
                  component="div"
                >
                  Product List
                </Typography>
              )}
              {/* {numSelected > 0 && numSelected < 2 && (
                <div>
                  <Tooltip title="Edit">
                    <IconButton aria-label="edit">
                      <EditIcon onClick={props.handleEdit} fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </div>
              )} */}

              {/* {numSelected > 0 ? (
                <Tooltip title="Delete">
                  <IconButton aria-label="delete">
                    <DeleteIcon onClick={props.handleDelete} fontSize="small" />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title="Filter list">
                  <IconButton aria-label="filter list">
                    <FilterListIcon
                      className={classes.filterIcon}
                      fontSize="small"
                    />
                  </IconButton>
                </Tooltip>
              )} */}
            </div>
          </TableCell>
        </TableRow>
      )}
    </TableHead>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  container: {
    // marginTop: 65,
    width: "100%",
  },
  addIcon: {
    // marginRight: 8,
    color: "#fff",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableHead: {
    backgroundColor: "#336699",
    fontWeight: "bold",
    color: "#fff",
  },
  root: {
    "&:hover": {
      color: "#64B2CB",
    },
    color: "#fff",
    fontWeight: "bold",
    backgroundColor: "#336699",
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },

  rowListContainer: {
    padding: 0,
    // display: 'none', //wip
  },
  rowListCheck: {
    fontSize: 12,
    fontWeight: "bold",
  },

  actionsContainer: {
    display: "flex",
    backgroundColor: "#336699",
    fontWeight: "bold",
    color: "#fff",
    borderRadius: "4px 4px 0px 0px",
  },
  actionsItem: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 16,
  },
  addItem: {
    alignItems: "center",
    display: "flex",
    flexGrow: 1,
    justifyContent: "flex-end",
  },
}));

export default function CustomTable(props) {
  const {
    cellList,
    data,
    headCells,
    rowList,
    setRowList,
    handleSearch,
    handleClear,
    searchTerm,
    setSearchTerm,
    selectNames,
    checked,
    area,
    names,
    handleToggle,
    actionsLists,
    actionsHandleChange,
    actionsNames,
    setDateBefore,
    setDateAfter,
    dateAfter,
    dateBefore,
    noChecks,
    clientProp,
    page,
    setPage,
    productsAmount,
    handleMore,
    handleRequestSort,
    sortProperty,
    sortDirection,
    rowsPerPage,
    setRowsPerPage,
    getFullList,
    rowsPerPageOptions,
  } = props;
  const classes = useStyles();
  const [calcOpen, setCalcOpen] = useState(false);
  // const [order, setOrder] = useState("asc");
  // const [orderBy, setOrderBy] = useState("calories");
  const [selected, setSelected] = useState([]);
  // const [page, setPage] = useState(0);
  const [dense, setDense] = useState(true);
  // const [rowsPerPage, setRowsPerPage] = useState(25);
  // const [rowList, setRowList] = useState([...headCells]);
  const [editItem, setEdit] = useState(false);
  const [statusList, setStatusList] = useState([
    { id: 1, value: "Active", name: "Active" },
    { id: 2, value: "Inactive", name: "Inactive" },
    { id: 3, value: "Deleted", name: "Deleted" },
    { id: 5, value: "Pending", name: "Pending" },
    { id: 16, value: "Dispatched", name: "Dispatched" },
    { id: 9, value: "Completed", name: "Completed" },
    { id: 21, value: "Declined", name: "Declined" },
    { id: 23, value: "Refunded", name: "Refunded" },
    { id: 24, value: "Processing", name: "Processing" },
    { id: 27, value: "Approved", name: "Approved" },
  ]);

  // const handleRequestSort = (event, property) => {
  //   const isAsc = orderBy === property && order === "asc";
  //   setOrder(isAsc ? "desc" : "asc");
  //   setOrderBy(property);
  // };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = data.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const getParent = (category, list) => {
    if (category.parentID === null) {
      return;
    } else {
      let parent = list.filter((cats) => cats.id === category.parentID);
      return parent[0];
    }
  };

  const getParents = (category, list) => {
    console.log("firing get parents");
    let parentsArr = [];
    let hasParent = true;
    let currentCat = JSON.parse(JSON.stringify(category));
    while (hasParent) {
      let parent = getParent(currentCat, list);
      if (parent) {
        parentsArr.push(parent.name);
        currentCat = parent;
      } else {
        hasParent = false;
      }
    }

    return parentsArr.length ? parentsArr.reverse().join(" > ") : "";
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

  const handleRowFilter = (event) => {
    // rowList.map((item) => console.log(item))
    setRowList(
      rowList.map((item) =>
        item.object
          ? item.nestedObject
            ? item.nestedObjectProperty === [event.target.name][0]
              ? { ...item, checked: event.target.checked }
              : item
            : item.objectProperty === [event.target.name][0]
            ? { ...item, checked: event.target.checked }
            : item
          : item.id === [event.target.name][0]
          ? { ...item, checked: event.target.checked }
          : item
      )
    );
  };
  // page specific items

  const handleEdit = () => {};

  const [descOpen, setDescOpen] = useState(false);
  const [descText, setDescText] = useState(false);
  const [imgOpen, setImgOpen] = useState(false);
  const [imgList, setImgList] = useState([]);

  const handleDescriptionDialog = (event, text) => {
    setDescText(text);
    setDescOpen(true);
  };
  const handleCategoryDialog = (event, text) => {
    setDescText(text.map((text) => text.name).join(" > "));
    setDescOpen(true);
  };
  const handleImageDialog = (event, imgList) => {
    if (imgList) {
      setImgList(imgList);
      setImgOpen(true);
    }
  };

  const handleEditClick = (event, id) => {
    props.handleEditClick(id);
    setEdit(true);
  };

  const handleDelete = () => {};
  const handleCalculator = () => {
    setCalcOpen(true);
  };
  let selectedItem = data.filter((dataItem) => dataItem.id === selected[0]);
  let timeZoneOptions = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    timeZone: "Australia/Sydney",
  };

  return (
    <div className={classes.container}>
      <Container style={{ minWidth: 1500, maxWidth: "100%" }}>
        <Paper className={classes.paper}>
          <TableActions
            classes={classes}
            numSelected={selected.length}
            onRequestSort={handleRequestSort}
            headCells={headCells}
            rowList={rowList}
            handleRowFilter={handleRowFilter}
            handleSearch={handleSearch}
            handleClear={handleClear}
            setSearchTerm={setSearchTerm}
            searchTerm={searchTerm}
            editItem={editItem}
            checked={checked}
            names={names}
            handleToggle={handleToggle}
            actionsLists={actionsLists}
            actionsHandleChange={actionsHandleChange}
            actionsNames={actionsNames}
            area={area}
            selectNames={selectNames}
            selected={selected}
            selectedItem={selectedItem[0]}
            data={data}
            setDateBefore={setDateBefore}
            setDateAfter={setDateAfter}
            dateAfter={dateAfter}
            dateBefore={dateBefore}
            clientProp={clientProp}
            productsAmount={productsAmount}
            getFullList={getFullList}
          />
          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size={dense ? "small" : "medium"}
              aria-label="enhanced table"
            >
              <EnhancedTableHead
                classes={classes}
                numSelected={selected.length}
                order={sortDirection}
                orderBy={sortProperty}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={data.length}
                selectAll={!noChecks}
                headCells={headCells}
                rowList={rowList}
              />
              <EnhancedTableToolbar
                handleEdit={handleEdit}
                handleCalculator={handleCalculator}
                handleDelete={handleDelete}
                numSelected={selected.length}
                selected={selected}
                cols={headCells.length + 1}
                area={area}
                data={data}
              />
              <TableBody>
                {stableSort(data, getComparator(sortDirection, sortProperty))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    const isItemSelected = isSelected(row.id);
                    const labelId = `enhanced-table-checkbox-${index}`;
                    return (
                      <StyledTableRow
                        hover
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={`${row.username}-${index}`}
                        selected={isItemSelected}
                      >
                        <StyledTableCell
                          padding="checkbox"
                          onClick={(event) => handleClick(event, row.id)}
                          style={
                            noChecks
                              ? { display: "none" }
                              : { display: "table-cell", maxWidth: 50 }
                          }
                        >
                          <Checkbox
                            checked={isItemSelected}
                            inputProps={{ "aria-labelledby": labelId }}
                          />
                        </StyledTableCell>
                        {cellList.map((cell, index) => {
                          return (
                            <StyledTableCell
                              key={index}
                              align={"left"}
                              // align={
                              //   headCells[index].numeric ? "right" : "left"
                              // }
                              onClick={
                                cell === "sku" || cell === "name"
                                  ? null
                                  : cell === "longDescription"
                                  ? (event) =>
                                      handleDescriptionDialog(event, row[cell])
                                  : cell === "categories"
                                  ? (event) =>
                                      handleCategoryDialog(event, row[cell])
                                  : cell === "images"
                                  ? (event) =>
                                      handleImageDialog(event, row[cell])
                                  : (event) => handleEditClick(event, row.id)
                              }
                              style={
                                index === 0 && noChecks
                                  ? {
                                      paddingLeft: 10,
                                      display: rowList[index].checked
                                        ? "table-cell"
                                        : "none",
                                    }
                                  : (rowList[index].checked &&
                                      cell === "sku") ||
                                    (rowList[index].checked && cell === "name")
                                  ? { visiblity: "visible", cursor: "auto" }
                                  : rowList[index].checked && cell === "images"
                                  ? {
                                      visiblity: "visible",
                                      cursor: "pointer",
                                      display: "flex",
                                      minHeight: 30,
                                      alignItems: "center",
                                      paddingTop: 2,
                                      paddingBottom: 2,
                                      justifyContent: "center",
                                    }
                                  : rowList[index].checked
                                  ? { visiblity: "visible" }
                                  : { display: "none" }
                              }
                            >
                              {cell === "categories" ? (
                                row.categories &&
                                row.categories
                                  .map(function (obj) {
                                    return obj.name;
                                  })
                                  .join(", ")
                              ) : cell === "updatedAt" ||
                                cell === "createdAt" ||
                                cell === "lastLogin" ? (
                                new Intl.DateTimeFormat(
                                  "en-AU",
                                  timeZoneOptions
                                ).format(new Date(row[cell]))
                              ) : cell === "statusID" ? (
                                      statusList
                                          .filter((status) => status.id === row.statusID)[0]?.name || ""
                              ) : // row.statusID === 1 ? (
                              cell === "parentID" ? (
                                row[cell] && getParents(row, data)
                              ) : // row.statusID === 1 ? (
                              //   "Active"
                              // ) : row.statusID === 2 ? (
                              //   "Inactive"
                              // ) : row.statusID === 3 ? (
                              //   "Deleted"
                              // ) : row.statusID === 5 ? (
                              //   "Pending"
                              // ) : (
                              //   ""
                              // )
                              cell === "margin" ? (
                                (Number(row[cell]) * 100).toFixed(2)
                              ) : headCells[index].numeric ? (
                                (Number(row[cell]) / 100).toLocaleString(
                                  "en-US",
                                  {
                                    style: "currency",
                                    currency: "USD",
                                  }
                                )
                              ) : cell === "ordersByInvoice" ? (
                                <Link to={`/orders?invoice=${row.id}`}>
                                  View Orders
                                </Link>
                              ) : cell === "ordersByOrderProduct" ? (
                                <Link to={`/orders?order=${row.orderID}`}>
                                  View Order
                                </Link>
                              ) : cell === "purchaseOrdersByInvoice" ? (
                                <Link to={`/order-products?invoice=${row.id}`}>
                                  View Purchase Orders
                                </Link>
                              ) : cell === "invoicesByOrderProduct" ? (
                                <Link to={`/invoices?invoice=${row.invoiceID}`}>
                                  View Invoice
                                </Link>
                              ) : cell === "invoicesByOrder" ? (
                                row.invoiceID && (
                                  <Link
                                    to={`/invoices?invoice=${row.invoiceID}`}
                                  >
                                    View Invoice
                                  </Link>
                                )
                              ) : cell === "images" &&
                                row[cell] &&
                                row[cell].length ? (
                                <img
                                  width={25}
                                  // className={classes.productImage}
                                  // src={`process.env.REACT_APP_ASSETS_URL/products/404/images/473143_260-0.jpeg`}
                                  src={
                                    `${process.env.REACT_APP_ASSETS_URL}/` +
                                    row[cell][0].objName
                                  }
                                  alt={row[cell][0].title}
                                />
                              ) : rowList[index].nestedObject ? (
                                row[cell][rowList[index].objectProperty][0][
                                  rowList[index].nestedObjectProperty
                                ]
                              ) : rowList[index].object ? (
                                row[cell][rowList[index].objectProperty]
                              ) : row[cell] ? (
                                row[cell]
                              ) : (
                                ""
                              )}
                            </StyledTableCell>
                          );
                        })}
                      </StyledTableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: dense ? 33 : 53 }}>
                    <StyledTableCell
                      colSpan={headCells.length ? headCells.length + 1 : 0}
                    />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={
              rowsPerPageOptions ? rowsPerPageOptions : [25, 50, 100]
            }
            component="div"
            count={productsAmount}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleMore}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            // onPageChange={handleMore}
            // onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Container>
      <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense"
      />
      <DescriptionDialog
        description={descText}
        setOpen={setDescOpen}
        open={descOpen}
      />
      <ImageDialog imageList={imgList} setOpen={setImgOpen} open={imgOpen} />
    </div>
  );
}
